export default (params) => ({
  trigger: {
    name: 'product_collection.select_property_value',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      property_name: {
        type: 'string',
      },
      property_value: {
        type: 'string',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'multi_discriminant_selector',
          'drop_down_selector',
          'drop_down_panel',
          'direct_collection',
          'stepped_selector',
          'collapsed_selector',
        ],
      },
    },
    event: {
      name: 'select_collection_item',
    },
    nonInt: false,
  },
});
